import React, { Component } from 'react';
import { string, shape, bool } from 'prop-types';
import { Form } from 'semantic-ui-react';
import MaskedInput from 'react-text-mask';
import { getIn } from 'formik';
import styles from './MaskedInput.less';

class MaskedInputField extends Component {
  static propTypes = {
    type: string,
    field: shape({}).isRequired,
    form: shape({}).isRequired,
    label: string,
    guide: bool,
    disabled: bool,
    separator: string,
    excludeSeparator: bool,
    placeholder: string,
  }

  static defaultProps = {
    label: '',
    type: 'string',
    guide: false,
    disabled: false,
    separator: ',',
    placeholder: '',
    excludeSeparator: false,
  }

  handleChange = (e) => {
    const {
      field: { name, onChange },
      form: { setFieldValue },
      excludeSeparator,
      separator,
      type,
    } = this.props;

    const regex = new RegExp(`\\b${separator}\\b`, 'g');
    let value = excludeSeparator && e.target.value ? e.target.value.replace(regex, '') : e.target.value;
    if (type === 'number') {
      value = +value;
    }

    setFieldValue(name, value);
    // onChange(value);
  }

  handleBlur = () => {
    const { field: { name }, form: { setFieldTouched } } = this.props;
    setFieldTouched(name);
  }

  render() {
    const {
      field: { name, value },
      form: { touched, errors },
      disabled,
      ...props
    } = this.props;

    const touch = getIn(touched, name);
    const error = getIn(errors, name);

    return (
      <Form.Field>
        {props.label && <label htmlFor={name} className={styles.label}>{props.label}</label>}
        <div className={styles.inputCurrency}>
          <MaskedInput
            id={name}
            showMask={false}
            mask={props.mask}
            value={value}
            guide={props.guide}
            placeholder={props.placeholder}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            disabled={disabled}
          />
          <span className={styles.currencyCode}>{props.currencyCode || null}</span>
        </div>
        {
          touch
          && error
          && <div className={styles.error}>{error}</div>
        }
      </Form.Field>
    );
  }
}

export default MaskedInputField;
